import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Block, PageContainer } from '@edikk-edikk/country-layout-black';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { GlobeAmericas } from '@edikk-edikk/icon/GlobeAmericas';
import { PopularCity } from '#home/components/card-popular-city-list/PopularCity';
import cityLinkListCss from './assets/city-link-list.module.scss';
import { useHomeContext } from '#home/hooks';

const CardPopularCityList: FC = () => {
  const { popularCityList } = useHomeContext();

  if (popularCityList.length === 0) {
    return null;
  }

  const popularCityElementList = popularCityList.map((city) => (
    <PopularCity key={city.id} city={city} />
  ));

  return (
    <PageContainer>
      <Block
        title={(
          <>
            <SvgIcon Component={GlobeAmericas} width={20} height={20} />
            <FormattedMessage defaultMessage="Most popular locations" />
          </>
        )}
        withoutBorderAndPadding
      >
        <div className={cityLinkListCss.cityLinkList}>
          {popularCityElementList}
        </div>
      </Block>
    </PageContainer>
  );
};

export { CardPopularCityList };
